import './WhyUs.less';

const whyUs = (() =>{


})()

export default whyUs;